import './styles.css';
import { BootScreen } from './BootScreen';
import { Game } from './Game';
import { createFeatureRegistry } from './features';

const container = document.querySelector<HTMLElement>('#game');
if (!container) throw new Error('Game container was not found.');

const boot = new BootScreen();
const game = new Game(createFeatureRegistry());

Promise.all([game.init(container), boot.play()])
  .then(() => boot.dismiss())
  .catch(error => {
  console.error(error);
  document.body.innerHTML = `<main style="padding:2rem;color:#fff;background:#071116;min-height:100vh"><h1>BELOW could not start</h1><p>${error instanceof Error ? error.message : 'Unknown startup error'}</p><p>Reload the page. If the problem continues, verify that WebGL is enabled.</p></main>`;
});
